export const APP_RENDER_SUCCESS = 'APP_RENDER_SUCCESS';

export const appRenderSuccess = () => ({
  type: APP_RENDER_SUCCESS,
});
